import { ResponsiveContainer, AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Area } from "recharts";
import { format } from "date-fns";
import { ChartLine } from "lucide-react";
import { ChartCard } from "./ChartCard";
import { CustomTooltip } from "./CustomTooltip";
import { COLORS } from '../constants';

export const SessionTrendsChart = ({ data, isLoading }) => (
  <ChartCard title="Session Trends" icon={ChartLine} isLoading={isLoading} className="lg:col-span-2">
    {/* Reduced height for compactness */}
    <div className="h-[200px]">
      <ResponsiveContainer>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            tickFormatter={(value) => format(new Date(value), "MMM d")}
          />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Area
            type="monotone"
            dataKey="completedSessions"
            stroke={COLORS.primary}
            fill={COLORS.primary}
            fillOpacity={0.1}
            name="Completed"
          />
          <Area
            type="monotone"
            dataKey="scheduledSessions"
            stroke={COLORS.secondary}
            fill={COLORS.secondary}
            fillOpacity={0.1}
            name="Scheduled"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  </ChartCard>
);
